/* LYVN Diwali PLP: countdown, "As low as" price on cards, floating diya cart tracker */
(function () {
  if (window.__dwPlp) return;
  window.__dwPlp = true;

  var root = document.querySelector('[data-dw-plp]');
  if (!root) return;

  var tiers = (root.getAttribute('data-tiers') || '').split('|').map(function (t) {
    var p = t.split(':');
    return { min: parseInt(p[0], 10) || 1, off: parseFloat(p[1]) || 0, extra: (p[2] || '').trim() };
  }).filter(function (t) { return t.off > 0; });
  if (!tiers.length) return;
  var best = tiers[tiers.length - 1];
  var moneyFormat = root.getAttribute('data-money') || 'Rs. {{amount}}';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    function d(n, p, t, s) {
      var parts = (n / 100).toFixed(p).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts[1] ? parts[0] + s + parts[1] : parts[0];
    }
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/), k = m ? m[1] : 'amount', v;
    if (k === 'amount_no_decimals') v = d(cents, 0, ',', '.');
    else if (k === 'amount_with_comma_separator') v = d(cents, 2, '.', ',');
    else if (k === 'amount_no_decimals_with_comma_separator') v = d(cents, 0, '.', ',');
    else v = d(cents, 2, ',', '.');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------------- countdown ---------------- */
  var end = Date.parse(root.getAttribute('data-end'));
  var els = {};
  ['d', 'h', 'm', 's'].forEach(function (k) { els[k] = root.querySelector('[data-dw-t="' + k + '"]'); });
  if (!isNaN(end) && els.d) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var t = Math.max(0, end - Date.now());
      els.d.textContent = pad(Math.floor(t / 864e5));
      els.h.textContent = pad(Math.floor(t % 864e5 / 36e5));
      els.m.textContent = pad(Math.floor(t % 36e5 / 6e4));
      els.s.textContent = pad(Math.floor(t % 6e4 / 1e3));
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- "As low as" line on product cards ---------------- */
  var showLow = root.getAttribute('data-low') !== 'false';
  function priceOf(card) {
    var el = card.querySelector('.price ins .amount') || card.querySelector('.price .amount');
    if (!el) return null;
    // first number in the text, so the "." in "Rs." is ignored
    var m = el.textContent.match(/\d[\d.,]*/);
    if (!m) return null;
    var txt = m[0].replace(/[.,]$/, '');
    // "1,099.00" -> 109900 ; also handles "1.099,00"
    var cents;
    if (/,\d{2}$/.test(txt)) cents = Math.round(parseFloat(txt.replace(/\./g, '').replace(',', '.')) * 100);
    else cents = Math.round(parseFloat(txt.replace(/,/g, '')) * 100);
    return isNaN(cents) ? null : cents;
  }
  function decorateCards() {
    if (!showLow) return;
    document.querySelectorAll('.product-card').forEach(function (card) {
      if (card.__dwLow) return;
      var info = card.querySelector('.product-card-info');
      var cents = priceOf(card);
      if (!info || !cents) return;
      card.__dwLow = true;
      var low = Math.floor(cents * (100 - best.off) / 100);
      var tag = document.createElement('span');
      tag.className = 'dw-low';
      tag.innerHTML = 'As low as <b>' + formatMoney(low) + '</b> in Buy ' + best.min;
      var price = info.querySelector('.price');
      if (price && price.parentNode === info) price.insertAdjacentElement('afterend', tag);
      else info.appendChild(tag);
    });
  }

  /* ---------------- floating diya tracker ---------------- */
  var tracker = document.querySelector('[data-dw-tracker]');
  var lamps = tracker ? tracker.querySelectorAll('.dw-lamp') : [];
  var msg = tracker ? tracker.querySelector('[data-dw-tmsg]') : null;
  var lastIdx = null;

  function sparkle(el) {
    if (reduce || !el || !el.animate) return;
    var r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var cols = ['#FFB547', '#FF8A1F', '#FF4D8D', '#FFF0A8', '#FFFFFF'];
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('i');
      s.style.cssText = 'position:fixed;left:' + cx + 'px;top:' + cy + 'px;width:5px;height:5px;border-radius:50%;pointer-events:none;z-index:9999;background:' + cols[i % 5] + ';box-shadow:0 0 6px ' + cols[i % 5];
      document.body.appendChild(s);
      var a = Math.random() * Math.PI * 2, dist = 30 + Math.random() * 50;
      s.animate([{ transform: 'translate(0,0)', opacity: 1 }, { transform: 'translate(' + Math.cos(a) * dist + 'px,' + (Math.sin(a) * dist - 20) + 'px) scale(.2)', opacity: 0 }],
        { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = (function (n) { return function () { n.remove(); }; })(s);
    }
  }

  function paintTracker(count) {
    if (!tracker) return;
    var idx = -1;
    tiers.forEach(function (t, i) { if (count >= t.min) idx = i; });
    lamps.forEach(function (l, i) {
      var was = l.classList.contains('lit');
      l.classList.toggle('lit', i <= idx);
      if (lastIdx !== null && i <= idx && !was) {
        l.classList.remove('is-new'); void l.offsetWidth; l.classList.add('is-new');
        setTimeout(function () { l.classList.remove('is-new'); }, 1000);
      }
    });
    if (lastIdx !== null && idx > lastIdx) sparkle(lamps[idx] || tracker);
    lastIdx = idx;

    var next = tiers[idx + 1];
    if (count === 0) {
      msg.innerHTML = 'Add a piece to light your first diya → <b>' + tiers[0].off + '% off</b>';
    } else if (next) {
      msg.innerHTML = '<b>' + tiers[idx].off + '% off</b> unlocked · add <b>' + (next.min - count) + ' more</b> for ' + next.off + '%' +
        (next.extra && idx + 1 >= 1 ? ' + ' + next.extra.replace(/^\S+\s/, '') : '');
    } else {
      msg.innerHTML = '🎉 All diyas lit! <b>' + best.off + '% off' + (best.extra ? ' + ' + best.extra.replace(/^\S+\s/, '') : '') + '</b>';
    }
  }

  var cartTimer;
  function loadCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { paintTracker(c && c.items ? (c.items || []).reduce(function (s, i) { return (i.handle === 'freebie' || i.handle === 'game-set') ? s : s + i.quantity; }, 0) : 0); })
        .catch(function () {});
    }, 300);
  }

  if (tracker) {
    tracker.querySelector('[data-dw-open-cart]').addEventListener('click', function (e) {
      var toggle = document.getElementById('cart-drawer-toggle');
      if (toggle) { e.preventDefault(); toggle.click(); }
    });
    document.addEventListener('cart:refresh', loadCart);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) loadCart(); });
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) new MutationObserver(loadCart).observe(drawer, { childList: true, subtree: true });
    loadCart();
  }

  /* cards arrive later with infinite scroll / filtering: watch the grid */
  decorateCards();
  var grid = document.getElementById('ProductGridContainer') || document.body;
  new MutationObserver(function () { decorateCards(); }).observe(grid, { childList: true, subtree: true });
})();
